/* eslint-disable */

import React, { useState } from 'react';
import axios from 'axios';
import { Form, Input, Button, Card, Space, Typography, Row, Col, message, Select } from 'antd';
import { SearchOutlined, SendOutlined, RocketOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;
const { Option } = Select;

function APISettingDellivery(props) {
  const [trackingForm] = Form.useForm();
  const [hookForm] = Form.useForm();

  const [loading, setLoading] = useState(false);
  const [hookLoading, setHookLoading] = useState(false);

  const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  async function api_Send_find_trackingcode(values) {
    setLoading(true);
    await sleep(500);

    const formData = new FormData();
    formData.append('order_id', values.order_id);
    formData.append('ship_by', values.ship_by);

    axios
      .post(
        'https://management.meya.co.th/api/notify/webhook/notify/delivery/findtracking',
        formData,
        {
          headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + props.permitdata.token,
          },
        },
      )
      .then((response) => {
        setLoading(false);
        if (response.data.status === 'OK') {
          hookForm.setFieldsValue({
            tracking_code: response.data.tracking_code,
          });
          message.success('ค้นพบรหัสพัสดุสำเร็จ');
        } else {
          hookForm.setFieldsValue({
            tracking_code: '',
          });
          message.error('เซิร์ฟเวอร์แจ้งเตือน Hook เกิดข้อผิดพลาด');
        }
      })
      .catch((err) => {
        setLoading(false);
        message.error(err.message || 'เชื่อมต่อเซิร์ฟเวอร์ล้มเหลว');
      });
  }

  async function api_Send_delivery_hook(values) {
    setHookLoading(true);
    await sleep(500);

    const formData = new FormData();
    formData.append('tracking_code', values.tracking_code);
    formData.append('order_status', values.order_status);

    axios
      .post('https://management.meya.co.th/api/notify/webhook/notify/delivery/shippop', formData, {
        headers: {
          Accept: 'application/json',
          Authorization: 'Bearer BAhAFE5C5xw22BGDylfIgi4L0zy51z2C7VcUchiTtLJx5kzi7yD1EhmoS28BEp7e',
        },
      })
      .then((response) => {
        setHookLoading(false);
        if (response.data.success === 1) {
          message.success('เซิร์ฟเวอร์แจ้งเตือน Hook ได้รับข้อมูลแล้ว');
        } else {
          message.error('เซิร์ฟเวอร์แจ้งเตือน Hook เกิดข้อผิดพลาด');
        }
      })
      .catch((err) => {
        setHookLoading(false);
        message.error(err.message || 'เชื่อมต่อเซิร์ฟเวอร์ล้มเหลว');
      });
  }

  return (
    <div className='page-card'>
      <Space direction='vertical' size='large' style={{ width: '100%' }}>
        <Card type='inner' title='ค้นหาหมายเลขพัสดุ (Tracking Code)'>
          <Form
            form={trackingForm}
            layout='vertical'
            onFinish={api_Send_find_trackingcode}
            initialValues={{ ship_by: 'shipping_tracking_code' }}
          >
            <Row gutter={16}>
              <Col xs={24} md={24}>
                <Form.Item
                  name='order_id'
                  label='รหัสคำสั่งซื้อ'
                  rules={[{ required: true, message: 'กรุณากรอกรหัสคำสั่งซื้อ' }]}
                >
                  <Input
                    size='large'
                    style={{ width: '100%' }}
                    placeholder='พิมพ์รหัสคำสั่งซื้อที่นี่'
                  />
                </Form.Item>
                <Form.Item
                  name='ship_by'
                  label='ประเภทการจัดส่ง (ผู้จัดส่ง)'
                  rules={[{ required: true, message: 'กรุณาเลือกประเภทการจัดส่ง' }]}
                >
                  <Select size='large' style={{ width: '100%' }}>
                    <Option value='shipping_tracking_code'>ผู้ขายส่ง (Seller)</Option>
                    <Option value='return_tracking_code'>ผู้ซื้อส่งคืน (Buyer)</Option>
                  </Select>
                </Form.Item>
                <Button
                  type='primary'
                  htmlType='submit'
                  icon={<SearchOutlined />}
                  loading={loading}
                >
                  ดึงรหัสพัสดุ Shippop
                </Button>
              </Col>
            </Row>
          </Form>
        </Card>

        <Card type='inner' title='ทดสอบเรียกตัวกระตุ้น Hook (Hook Trigger)'>
          <Form
            form={hookForm}
            layout='vertical'
            onFinish={api_Send_delivery_hook}
            initialValues={{ order_status: 'booking' }}
          >
            <Row gutter={16}>
              <Col xs={24} md={24}>
                <Form.Item
                  name='tracking_code'
                  label='รหัสพัสดุ Shippop'
                  rules={[{ required: true, message: 'กรุณากรอกรหัสพัสดุ' }]}
                >
                  <Input size='large' style={{ width: '100%' }} placeholder='รหัสพัสดุ' />
                </Form.Item>
                <Form.Item
                  name='order_status'
                  label='สถานะการจัดส่ง'
                  rules={[{ required: true, message: 'กรุณาเลือกสถานะ' }]}
                >
                  <Select size='large' style={{ width: '100%' }}>
                    <Option value='booking'>จองคิวรถขนส่ง (booking)</Option>
                    <Option value='cancel'>ยกเลิกรายการ (cancel)</Option>
                    <Option value='shipping'>กำลังจัดส่ง (shipping)</Option>
                    <Option value='package_detail'>รายละเอียดพัสดุ (package_detail)</Option>
                    <Option value='problem'>พบปัญหาการจัดส่ง (problem)</Option>
                    <Option value='complete'>จัดส่งสำเร็จ (complete)</Option>
                    <Option value='return'>สินค้าตีกลับ (return)</Option>
                    <Option value='pending_transfer'>รอโอนเงิน (pending_transfer)</Option>
                    <Option value='transferred'>โอนเงินเรียบร้อย (transferred)</Option>
                  </Select>
                </Form.Item>
                <Button
                  type='primary'
                  htmlType='submit'
                  icon={<RocketOutlined />}
                  loading={hookLoading}
                >
                  ส่งข้อมูล Hook
                </Button>
              </Col>
            </Row>
          </Form>
        </Card>
      </Space>
    </div>
  );
}

export default APISettingDellivery;
